import { CloudRenderingRegion } from "../hooks/types";

// Images get you a result even if cors is not there. Its an error but hey, we got a result.
function getImageLatency(url: string) {
  return new Promise<number>((resolve, reject) => {
    const callbackWrapper = (latency: number) => {
      // garbage measurement
      if (latency <= 3) {
        reject();
      } else {
        resolve(latency);
      }
    };

    const startTime = Date.now();
    const image = new Image();
    const timeCallback = function () {
      const endTime = Date.now();
      const timeElapsed = endTime - startTime;
      callbackWrapper(timeElapsed);
    };
    image.onerror = timeCallback;
    image.onload = timeCallback;
    image.src = `${url}?_q=${startTime}`;
  });
}

export async function latencyLookup(
  cloudRegion: CloudRenderingRegion,
  timeout: number = 1000,
): Promise<number> {
  const task = getImageLatency(cloudRegion.latencyTestUrl);

  await Promise.race([
    task,
    // max latency
    new Promise((_, reject) => setTimeout(() => reject(null), timeout)),
  ]);

  return await task;
}
